module.exports = __webpack_public_path__ + "img/en.d39f7a13.svg";